module.exports = __webpack_public_path__ + "img/huddelArea-JPL-Logo.a2246df5.svg";